<template>
  <vk-dialog
    :visible.sync="visible"
    :showTitle="false"
    width="400px"
    @close="closeDialog"
    class="address-dialog-component"
  >
    <img
      class="close-btn"
      src="@/assets/images/detail/close.svg"
      @click="closeDialog"
    />
    <div class="address-dialog-title">确认收货地址</div>
    <template v-if="defaultAddress.id">
      <div class="address-dialog-content">
        <div class="address-dialog-info">尊敬的家长，您的订单包含贵重实物，请您确认是否使用当前默认收货地址？</div>
        <div class="address-info">
          <p>收货信息：</p>
          <p>
            <span>收件人：</span>
            <span>{{defaultAddress.customerName}}</span>
            <span>联系电话：</span>
            <span>{{defaultAddress.customerMobile}}</span>
          </p>
          <p>收货地址：{{defaultAddress.province}}{{defaultAddress.city}}{{defaultAddress.address}}</p>
        </div>
        <div class="text-center">
          <span
            class="action-btn"
            @click="useDefaultAddress"
          >确认使用默认收货地址</span>
        </div>
        <div class="tips-module">
          <p>默认地址有变更？<span @click="goSetting">去设置</span></p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="address-dialog-content">
        <div class="address-dialog-info">尊敬的家长，您当前还未添加收货地址，请添加您的默认收货地址</div>
        <div class="address-note">注：添加完成后，请记得回到当前订单页面，再次点击“立即确认收货地址"确认哦，否则实物订单将无法发货。</div>
        <div class="text-center">
          <span
            class="action-btn"
            @click="goSetting"
          >添加默认收货地址</span>
        </div>
      </div>
    </template>
  </vk-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    defaultAddress: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    // 跳转到家长端个人设置页面
    goSetting() {
      window.location.href = window.location.origin + '/parent/setting'
    },
    useDefaultAddress() {
      this.$emit('useDefaultAddress', this.defaultAddress.id)
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
.address-dialog-component {
  .close-btn {
    position: absolute;
    top: 9px;
    right: 9px;
    height: 13px;
    width: 13px;
    cursor: pointer;
  }
  .address-dialog-title {
    margin-top: 20px;
    text-align: center;
    font-size: 22px;
    color: #000;
    line-height: 1;
  }
  .address-dialog-content {
    padding: 0 10px;
    .address-dialog-info {
      margin-top: 20px;
      color: #333;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }
    .address-note {
      text-align: center;
      color: #808080;
      font-size: 12px;
      margin: 20px auto 40px;
    }
    .address-info {
      padding: 5px 0 20px;
      p {
        margin-top: 10px;
        margin-bottom: 0;
        color: #999;
        font-size: 12px;
        line-height: 1.4;
        span {
          display: inline-block;
          color: #999;
          margin-right: 12px;
        }
        &:first-child {
          color: #000;
          font-size: 14px;
        }
        &:last-child {
          margin-top: 3px;
        }
      }
    }
    .action-btn {
      display: inline-block;
      height: 36px;
      line-height: 36px;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      background-color: #f85415;
      border-radius: 3px;
      padding: 0 20px;
    }
    .tips-module {
      color: #898993;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 14px;
      span {
        color: #f85415;
        cursor: pointer;
      }
    }
  }
}
</style>
